export { default as SearchProvider } from './SearchProvider';
export { getArrivalPort, reduceCruise } from './SearchContext.utils'; 